export type Section =
  | 'person'
  | 'controlData'
  | 'deathData'
  | 'judgmentData'
  | 'generality'
  | 'subjectAttributes'
  | 'subjectList'
  | 'birthdayDocument'
  | 'citizenship'
  | 'otherCitizenship'
  | 'parenthood'
  | 'profession';

type ContentState = {
  [key in Section]: boolean;
};

interface ContentStateActionPayload {
  section: Section;
}

interface ContentStateAction {
  type: 'toggle';
  payload: ContentStateActionPayload;
}

export const contenStateReducer = (
  state: ContentState,
  action: ContentStateAction
): ContentState => {
  switch (action.type) {
    case 'toggle':
      return {
        ...state,
        [action.payload.section]: !state[action.payload.section],
      };
  }
};

export const initialContentState: ContentState = {
  person: true,
  birthdayDocument: false,
  citizenship: false,
  controlData: false,
  deathData: false,
  generality: false,
  otherCitizenship: false,
  parenthood: false,
  subjectAttributes: false,
  judgmentData: false,
  subjectList: false,
  profession: false,
};
